import { render, staticRenderFns } from "./DefaultHeader.vue?vue&type=template&id=0d0f846c&"
import script from "./DefaultHeader.vue?vue&type=script&setup=true&lang=js&"
export * from "./DefaultHeader.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/opt/build/repo/components/Header.vue').default})
